export default __webpack_public_path__ + "static/static-asset-data-rollover-animation-c7cb0a4de6f750881db3802d0c79a4b0.gif";